import {
  FoBusiness,
  FpBusiness,
  YsBusiness
} from 'components/svg/BrandBusinessLogo';
import { BrandCodeEnum } from 'components/Theme/types';

import { ILogoProps } from './types';

export const Logo = ({ brandCode, ...rest }: ILogoProps) => {
  let LogoComponent = FoBusiness;

  switch (brandCode) {
    case BrandCodeEnum.fo:
      LogoComponent = FoBusiness;
      break;

    case BrandCodeEnum.fp:
      LogoComponent = FpBusiness;
      break;

    case BrandCodeEnum.ys:
      LogoComponent = YsBusiness;
      break;
  }

  return <LogoComponent {...rest} />;
};
